export default "__VITE_ASSET__CvuYv$eN__"